// ==================== UpcomingLeaves.jsx ====================
import React, { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import "../Styling/UpcomingLeaves.css";
import { useAuth } from "../Context/AuthContext";
import { Base_URL } from "../url";
import PastLeavesModal from "./PastLeavesModal";

const UpcomingLeaves = () => {
  const { user } = useAuth();
  const userId = user?.userId;
const [showPastModal, setShowPastModal] = useState(false);
  const [upcomingLeaves, setUpcomingLeaves] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;

    const fetchUpcomingLeaves = async () => {
      try {
        const response = await fetch(
          `${Base_URL}/Leave/upcoming-leaves/${userId}`
          
        );

        const result = await response.json();

        if (response.ok) {
          setUpcomingLeaves(result.data || []);
        } else {
          setUpcomingLeaves([]);
        }
      } catch (error) {
        console.error("Error fetching upcoming leaves:", error);
        setUpcomingLeaves([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUpcomingLeaves();
  }, [userId]);

  const formatDateRange = (start, end) => {
    const options = { month: "short", day: "numeric" };
    const startDate = new Date(start).toLocaleDateString("en-US", options);

    if (!end || start === end) return startDate;

    const endDate = new Date(end).toLocaleDateString("en-US", options);
    return `${startDate}–${endDate}`;
  };

 

  return (
    <>
    {/* Past Leaves Modal */}
      {showPastModal && (
        <PastLeavesModal
          userId={userId}
          onClose={() => setShowPastModal(false)}
        />
      )}
    <div className="upcomingleaves-card compact">
      
      {/* Header */}
      <div className="upcomingleaves-header compact">
        <div className="upcomingleaves-icon small">
          <CalendarDays size={16} />
        </div>
        <h4>Leaves</h4>
        <span className="header-badge clickable" onClick={()=>setShowPastModal(true)}>View Past Leaves</span>
      </div>

      {/* Content */}
      <div className="upcomingleaves-list compact">
        {loading ? (
          <div className="upcomingleaves-empty">Loading...</div>
        ) : upcomingLeaves.length > 0 ? (
          upcomingLeaves.map((leave, idx) => (
            <div key={idx} className="upcomingleaves-row">
              <span className="leave-type-chip">
                {leave.leaveType}
              </span>

              <span className="leave-dates">
                {formatDateRange(leave.startDate, leave.endDate)}
              </span>

              <span className="leave-days">
                {leave.days}d
              </span>

              <span
                className={`leave-status ${leave.status.toLowerCase()}`}
              >
                {leave.status}
              </span>
            </div>
          ))
        ) : (
          <div className="upcomingleaves-empty">
            No upcoming leaves
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default UpcomingLeaves;